import { article_getMentionedArticlesByRef_Api } from 'apis'
import { getId, getType } from 'apis/model/base'
import classNames from 'classnames'
import React, { useContext, useMemo } from 'react'
import { renderMentionsArticle } from 'views/Document/functions/renderMentionsArticle'
import EntityList from '../EntityList'
import { bindQueryParams } from '../functions/routerHelper'
import CodiContext from './CodiContext'

const CodiRelatedArticles = ({ style, className }) => {
  const { item } = useContext(CodiContext)

  const [id, type] = [getId(item), getType(item)]

  const apiInfo = article_getMentionedArticlesByRef_Api

  const refreshKey = useMemo(
    () => [apiInfo.path.replace(':id', id).replace(':type', type)].join('/'),
    [id, type]
  )

  return (
    <div
      style={style}
      className={classNames('flex flex-col', className)}>
      <EntityList
        apiInfo={apiInfo}
        refreshKey={refreshKey}
        RenderEntity={React.Fragment}
        renderItem={renderMentionsArticle}
        renderWrap={(child) => (
          <div className="flex flex-col gap-2">{child}</div>
        )}
        query={bindQueryParams([{ id }, { type }])}
      />
    </div>
  )
}

export default CodiRelatedArticles
